import { Stack } from '@optimus-web/core';
import { ConfigureSsoPanelIdentityFields } from './ConfigureSsoPanelIdentityFields';
import { ConfigureSsoPanelTokenFields } from './ConfigureSsoPanelTokenFields';

export function ConfigureSsoPanelConfig() {
    return (
        <Stack spacing="300" vertical>
            <ConfigureSsoPanelIdentityFields />
            <ConfigureSsoPanelTokenFields />
        </Stack>
    );
}
